import type { Translation } from 'primeng/api';

/** Textos en español para componentes PrimeNG (calendario, tabla, filtros, etc.). */
export const PRIME_NG_SPANISH: Translation = {
  startsWith: 'Empieza con',
  contains: 'Contiene',
  notContains: 'No contiene',
  endsWith: 'Termina con',
  equals: 'Igual a',
  notEquals: 'No es igual',
  noFilter: 'Sin filtro',
  lt: 'Menor que',
  lte: 'Menor o igual a',
  gt: 'Mayor que',
  gte: 'Mayor o igual a',
  is: 'Es',
  isNot: 'No es',
  before: 'Antes',
  after: 'Después',
  dateIs: 'Fecha es',
  dateIsNot: 'Fecha no es',
  dateBefore: 'Fecha antes de',
  dateAfter: 'Fecha después de',
  clear: 'Limpiar',
  apply: 'Aplicar',
  matchAll: 'Coincidir con todos',
  matchAny: 'Coincidir con cualquiera',
  addRule: 'Agregar regla',
  removeRule: 'Eliminar regla',
  accept: 'Sí',
  reject: 'No',
  choose: 'Elegir',
  upload: 'Subir',
  cancel: 'Cancelar',
  completed: 'Completado',
  pending: 'Pendiente',
  fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
  dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
  dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
  dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
  monthNames: [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ],
  monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
  dateFormat: 'dd/mm/yy',
  firstDayOfWeek: 0,
  today: 'Hoy',
  weekHeader: 'Sem',
  weak: 'Débil',
  medium: 'Media',
  strong: 'Fuerte',
  passwordPrompt: 'Introduce una contraseña',
  emptyMessage: 'No hay resultados',
  emptyFilterMessage: 'No se encontraron resultados',
  emptySearchMessage: 'Sin resultados',
  fileChosenMessage: '{0} archivos',
  noFileChosenMessage: 'Ningún archivo seleccionado',
  chooseYear: 'Seleccionar año',
  chooseMonth: 'Seleccionar mes',
  chooseDate: 'Seleccionar fecha',
  prevDecade: 'Década anterior',
  nextDecade: 'Década siguiente',
  prevYear: 'Año anterior',
  nextYear: 'Año siguiente',
  prevMonth: 'Mes anterior',
  nextMonth: 'Mes siguiente',
  prevHour: 'Hora anterior',
  nextHour: 'Hora siguiente',
  prevMinute: 'Minuto anterior',
  nextMinute: 'Minuto siguiente',
  prevSecond: 'Segundo anterior',
  nextSecond: 'Segundo siguiente',
  am: 'a.m.',
  pm: 'p.m.',
  searchMessage: '{0} resultados disponibles',
  selectionMessage: '{0} elementos seleccionados',
  emptySelectionMessage: 'Ningún elemento seleccionado',
  aria: {
    trueLabel: 'Verdadero',
    falseLabel: 'Falso',
    nullLabel: 'No seleccionado',
    star: '1 estrella',
    stars: '{star} de {stars} estrellas',
    selectAll: 'Seleccionar todo',
    unselectAll: 'Deseleccionar todo',
    close: 'Cerrar',
    previous: 'Anterior',
    next: 'Siguiente',
    navigation: 'Navegación',
    scrollTop: 'Desplazar al inicio',
    moveTop: 'Mover al inicio',
    moveUp: 'Subir',
    moveDown: 'Bajar',
    moveBottom: 'Mover al final',
    moveToTarget: 'Mover al destino',
    moveToSource: 'Mover al origen',
    moveAllToTarget: 'Mover todo al destino',
    moveAllToSource: 'Mover todo al origen',
    pageLabel: 'Página {page}',
    firstPageLabel: 'Primera página',
    lastPageLabel: 'Última página',
    nextPageLabel: 'Página siguiente',
    prevPageLabel: 'Página anterior',
    rowsPerPageLabel: 'Filas por página',
    previousPageLabel: 'Página anterior',
    jumpToPageDropdownLabel: 'Ir a la página',
    jumpToPageInputLabel: 'Ir a la página',
    selectRow: 'Fila seleccionada',
    unselectRow: 'Fila no seleccionada',
    expandRow: 'Expandir fila',
    collapseRow: 'Contraer fila',
    showFilterMenu: 'Mostrar menú de filtro',
    hideFilterMenu: 'Ocultar menú de filtro',
    filterOperator: 'Operador de filtro',
    filterConstraint: 'Restricción de filtro',
    editRow: 'Editar fila',
    saveEdit: 'Guardar edición',
    cancelEdit: 'Cancelar edición',
    listView: 'Vista de lista',
    gridView: 'Vista de cuadrícula',
    slide: 'Diapositiva',
    slideNumber: '{slideNumber}',
    zoomImage: 'Ampliar imagen',
    zoomIn: 'Acercar',
    zoomOut: 'Alejar',
    rotateRight: 'Rotar a la derecha',
    rotateLeft: 'Rotar a la izquierda',
    listLabel: 'Lista de opciones',
    selectColor: 'Seleccionar color',
    removeLabel: 'Eliminar',
    browseFiles: 'Examinar archivos',
    maximizeLabel: 'Maximizar',
    minimizeLabel: 'Minimizar',
  },
};
